"use client";
import React, { useEffect, useRef } from 'react';

const clients = [
  'UCC',
  'Infraroad',
  'Tadmur',
  'Imar',
  'Gulf Asia',
  'Gulfar',
  'Larsen & Toubro',
  'Leusure',
  'Super Angry World',
  'Baladna',
  'Snow Dunes',
  'Descon',
  'QDSBG',
  'HBK',
  'Petrocon',
  'Metito',
  'Qatar Energy',
  'Qatar Airways',
  'Builder',
  'Aspire Katara Hospitality',
  'Waldorf Astoria',
  'Al Mirqub',
  'Arabian MEP',
  'Spie',
  'Plazza Hotel',
  'Voltas',
  'CCC',
  'Cesco',
  'QDVC',
  'Midmac',
  'Hyunrai',
  'Qatar Gas',
];

export default function ClientsMarquee() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-hidden').forEach((el) => {
              el.classList.add('revealed');
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const doubled = [...clients, ...clients];

  return (
    <section id="clients" ref={ref} className="relative py-24 overflow-hidden" style={{ background: '#071e3d' }}>
      <div
        className="glow-orb w-[400px] h-[400px] top-1/2 left-1/4 -translate-y-1/2 opacity-15"
        style={{ background: 'rgba(0,194,255,0.3)' }}
      />

      <div className="max-w-[1280px] mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-14 reveal-hidden">
          <p className="eyebrow mb-4">OUR CLIENTS</p>
          <h2
            className="text-3xl lg:text-5xl font-extrabold text-fg"
            style={{ fontFamily: 'Syne, sans-serif' }}
          >
            Trusted by Qatar's{' '}
            <span className="gradient-text">Industry Leaders</span>
          </h2>
        </div>
      </div>

      {/* Marquee — full width */}
      <div className="relative overflow-hidden fade-edges reveal-hidden">
        <div className="marquee-track">
          {doubled.map((client, i) => (
            <div
              key={`${client}-${i}`}
              className="flex-shrink-0 mx-4 px-8 py-5 rounded-xl flex items-center justify-center"
              style={{
                background: 'rgba(10,36,80,0.6)',
                border: '1px solid rgba(255,255,255,0.06)',
                minWidth: '200px',
                transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.borderColor = 'rgba(0,194,255,0.3)';
                (e.currentTarget as HTMLElement).style.boxShadow = '0 4px 20px rgba(0,194,255,0.1)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.06)';
                (e.currentTarget as HTMLElement).style.boxShadow = 'none';
              }}
            >
              <span
                className="text-muted font-semibold text-sm whitespace-nowrap"
                style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
              >
                {client}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Stats below */}
      <div className="max-w-[1280px] mx-auto px-6 mt-14">
        <div
          className="reveal-hidden grid grid-cols-1 sm:grid-cols-3 gap-6 p-8 rounded-2xl text-center"
          style={{
            background: 'rgba(10,36,80,0.4)',
            border: '1px solid rgba(255,255,255,0.06)',
          }}
        >
          {[
            { val: '32+', label: 'Enterprise Clients' },
            { val: '98%', label: 'Client Retention Rate' },
            { val: '12+', label: 'Years Average Partnership' },
          ].map((s) => (
            <div key={s.label}>
              <div
                className="text-3xl font-extrabold gradient-text mb-1"
                style={{ fontFamily: 'Syne, sans-serif' }}
              >
                {s.val}
              </div>
              <div
                className="text-muted text-sm uppercase tracking-[1px] font-bold"
                style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
              >
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}